export default __webpack_public_path__ + "static/media/logo-mark.d38e100d.png";